import type { JSX } from "react";
import type { ClassNameProp } from "@charterindex/armoury-www";
import type { DeletionVerb } from "../../crud-operation/delete-operation";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";


export type ConfirmDeletionCheckboxProps = ClassNameProp & {
	resourceName: string | undefined | null;
	verb?: DeletionVerb;
};
export const ConfirmDeletionCheckbox = (p: ConfirmDeletionCheckboxProps): JSX.Element => {
	const { t } = useTranslation();

	return (
		<FormControlLabel
			className={ p.className }
			label={ (
				<Trans
					t={ t }
					i18nKey={ `common:${p.verb ?? "delete"}Confirmation` }
					values={{ name: p.resourceName ?? "" }}
					components={{ strong: <strong/> }}
				/>
			) }
			control={ <Checkbox required/> }
		/>
	);
};
